import React, { FC } from 'react';

import { Loader } from '../../common';
import styles from './PaginationLoadMore.module.scss';

interface PaginationLoadMoreProps {
  loaded: number;
  total: number;
  loading: boolean;
  page: number;
  onLoadMore: () => void;
  onReset: () => void;
}

export const PaginationLoadMore: FC<PaginationLoadMoreProps> = ({
  loaded,
  total,
  page,
  loading,
  onLoadMore,
  onReset,
}) => {
  const hasMore = loaded < total;
  const isFirstPage = page === 1;
  const atEnd = loaded >= total;

  if (atEnd && isFirstPage) return null;

  return (
    <div className={styles.paginationLoadMore}>
      {hasMore && (
        <button
          className={styles.paginationLoadMore__button}
          onClick={onLoadMore}
          disabled={loading}
        >
          {loading ? <Loader size={'small'} overlay={false} /> : 'Показать ещё'}
        </button>
      )}

      {atEnd && !isFirstPage && (
        <button className={styles.paginationLoadMore__button} onClick={onReset} disabled={loading}>
          Скрыть
        </button>
      )}
    </div>
  );
};
